/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Pain_Since_MonthInputs */

const en_us2_profile_editors_pain_since_month = /** @type {(inputs: Profile_Editors_Pain_Since_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About a month ago`)
};

const pt_br2_profile_editors_pain_since_month = /** @type {(inputs: Profile_Editors_Pain_Since_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há 1 mês`)
};

const es_419_profile_editors_pain_since_month = /** @type {(inputs: Profile_Editors_Pain_Since_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hace un mes`)
};

const pt_pt2_profile_editors_pain_since_month = /** @type {(inputs: Profile_Editors_Pain_Since_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há cerca de 1 mês`)
};

const fr_fr2_profile_editors_pain_since_month = /** @type {(inputs: Profile_Editors_Pain_Since_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Environ un mois`)
};

const de_de2_profile_editors_pain_since_month = /** @type {(inputs: Profile_Editors_Pain_Since_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seit etwa einem Monat`)
};

const it_it2_profile_editors_pain_since_month = /** @type {(inputs: Profile_Editors_Pain_Since_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da circa un mese`)
};

/**
* | output |
* | --- |
* | "About a month ago" |
*
* @param {Profile_Editors_Pain_Since_MonthInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_pain_since_month = /** @type {((inputs?: Profile_Editors_Pain_Since_MonthInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Pain_Since_MonthInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_pain_since_month(inputs)
	if (locale === "es-419") return es_419_profile_editors_pain_since_month(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_pain_since_month(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_pain_since_month(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_pain_since_month(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_pain_since_month(inputs)
	return en_us2_profile_editors_pain_since_month(inputs)
});
export { profile_editors_pain_since_month as "profile-editors.pain_since_month" }